// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
import '../../styles/components/ItineraryList.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import moment from 'moment-timezone';
import TravelsList from '../events/TravelList/TravelsList';
import AccomodationsList from '../events/AccomodationList/AccomodationList';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { DayEvents } from '../events/DayEvents';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import BudgetWidget from './BudgetWidget';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import CollapsableItem from '../utils/CollapsableItem';

const LODGING = 'Lodging';
const FLIGHT = 'Flight';

function isOtherEvent(day, event, tz) {
  if (
    event.eventCategory === LODGING ||
    event.eventCategory === FLIGHT ||
    event.dateTBD
  ) {
    return false;
  }
  return (
    moment(event.startTime).tz(tz).format('YYYY-MM-DD') ===
    moment(day).tz(tz).format('YYYY-MM-DD')
  );
}

function isOverboardEvent(event, tz, startTime, endTime) {
  if (event.eventName === 'Flight' || event.eventCategory === LODGING) {
    return false;
  }
  if (!event.dateTBD) {
    return (
      moment(event.startTime).tz(tz).valueOf() <
        moment(startTime).tz(tz).valueOf() ||
      moment(event.startTime).tz(tz).valueOf() >
        moment(endTime).tz(tz).hour(23).minute(59).valueOf()
    );
  }
  return false;
}

export class ItineraryList extends React.PureComponent {
  addEvent = ({ currentTarget }) => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { addEventInDay } = this.props;
    const date = currentTarget.getAttribute('day');
    addEventInDay(date);
  };

  isDayEvent = (event, day, tz) => isOtherEvent(day, event, tz);

  render() {
    const {
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      content,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      status,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      startTime,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      endTime,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      dates,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      addTravelInfo,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      addAccommodationInfo,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      partyTz,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      onEventClick,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      members,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      addEvent,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      refs,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      isExpanded,
    } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    const overboardEvents = content.filter(event =>
      isOverboardEvent(event, partyTz, startTime, endTime)
    );
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    const TBDEvents = content.filter(
      event =>
        event.dateTBD &&
        event.eventCategory !== 'Flight' &&
        event.eventCategory !== 'Lodging'
    );
    const isEmpty = !overboardEvents || overboardEvents.length === 0;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    const travels = content.filter(event => event.eventCategory === 'Flight');
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    const accomodations = content.filter(
      event => event.eventCategory === 'Lodging'
    );
    return (
      <Fragment>
        <div className='data-box'>
          <h4 className='header' style={{ paddingLeft: '0px' }}>
            Travel Info
          </h4>
          <button
            type='button'
            className='btn btn-def'
            disabled={status}
            onClick={addTravelInfo}
          >
            + Add Info
          </button>
          <div className='clearfix' />
          {travels.length > 0 && (
            <CollapsableItem isExpanded={isExpanded}>
              <TravelsList
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                events={travels}
                tz={partyTz}
                handleOnClick={onEventClick}
              />
            </CollapsableItem>
          )}
        </div>
        <div className='data-box'>
          <h4 className='header' style={{ paddingLeft: '0px' }}>
            Accommodation Info
          </h4>
          <button
            type='button'
            className='btn btn-def'
            disabled={status}
            onClick={addAccommodationInfo}
            style={{ marginBottom: '10px' }}
          >
            + Add Info
          </button>
          <div className='clearfix' />
          {accomodations.length > 0 && (
            <CollapsableItem isExpanded={isExpanded}>
              <AccomodationsList
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                events={accomodations}
                tz={partyTz}
                handleOnClick={onEventClick}
              />
            </CollapsableItem>
          )}
        </div>
        <div className='data-box'>
          <h4 className='header' style={{ paddingLeft: '0px' }}>
            Events
          </h4>
          <button
            type='button'
            className='btn btn-def'
            disabled={status}
            onClick={addEvent}
          >
            + Add Event
          </button>
          <div className='clearfix' />
          {
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            // eslint-disable-next-line react/prop-types
            <CollapsableItem ref={refs.eventsBlockRef} isExpanded={isExpanded}>
              <BudgetWidget content={content} />
              {/* TODO: Fix this the next time the file is edited. */}
              {/* eslint-disable-next-line react/prop-types */}
              {dates.map(day => {
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                const filteredEvents = content.filter(event =>
                  this.isDayEvent(event, day, partyTz)
                );
                return (
                  <div
                    className='day-content'
                    key={day}
                    style={{ marginBottom: '24px' }}
                  >
                    <div className='event-header'>
                      {moment(day).tz(partyTz).format('ddd MMM DD YYYY')}
                    </div>
                    <DayEvents
                      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                      // @ts-ignore
                      events={filteredEvents}
                      members={members}
                      status={status}
                      day={day}
                      tz={partyTz}
                      Overboard={false}
                      onEventClick={onEventClick}
                      addEvent={this.addEvent}
                    />
                  </div>
                );
              })}
              {!isEmpty && (
                <div
                  className='day-content'
                  key='other'
                  style={{ marginBottom: '24px' }}
                >
                  <div className='event-header'>Other Events</div>
                  <DayEvents
                    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                    // @ts-ignore
                    events={overboardEvents}
                    tz={partyTz}
                    overboard
                    startTime={startTime}
                    status={status}
                    members={members}
                    endTime={endTime}
                    onEventClick={onEventClick}
                  />
                </div>
              )}
              <div className='day-content' key='other'>
                <div className='event-header'>TBD</div>
                <DayEvents
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  events={TBDEvents}
                  tz={partyTz}
                  tbd
                  startTime={startTime}
                  status={status}
                  members={members}
                  endTime={endTime}
                  onEventClick={onEventClick}
                  addEvent={this.addEvent}
                />
              </div>
            </CollapsableItem>
          }
        </div>
      </Fragment>
    );
  }
}
